<template>
  <div class="container_box">
    <div class="billWarehousing_box">
      <h2 class="title">{{ $t('key1002647') }}</h2>
      <Input size="large"
        class="scan_input"
        :element-id="'scanning'"
        :placeholder="$t('key1004051')"
        v-model.trim="scanInput"
        @on-enter="enterScanInput">
      </Input>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="510"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import {setConfigCharacters} from "@/utils/common";

export default {
  name: "billWarehousing",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      scanInput: '',
      tableColumns: [
        {
          title: 'NO',
          key: 'index',
          align: 'center',
          width: 90,
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001775'),
          key: 'supplierPickupOrderNumber',
          minWidth: 120,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004047'),
          key: 'thirdPickupOrderNumber',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            let thirdPickupOrderNumber = params.row.thirdPickupOrderNumber || '-';
            return h('span', thirdPickupOrderNumber);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001571'),
          key: 'logisticsInfo',
          align: 'center',
          minWidth: 150,
          render(h, params) {
            let carrierName = params.row.carrierName || '-';
            let deliveryType = params.row.deliveryType; // 发货方式{1YMS物流 2自有物流}
            let transportType = params.row.transportType; // 运输方式{1快递 2上门揽收}
            let expressageCode =params.row.expressageCode;
            let text = '-';
            let expressageNo = params.row.expressageNo;
            let trackingNumber = params.row.trackingNumber;
            let code = deliveryType === 2 ? expressageNo : trackingNumber;
            if (deliveryType === 1 && transportType === 2) {
              text = `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001582')}`;
            } else {
              if (transportType === 1 && deliveryType === 1) {
                text = carrierName;
              } else {
                if (v.useLogisticsList.length > 0) {
                  v.useLogisticsList.map((item) => {
                    if (item.carrierId === expressageCode) {
                      text = item.carrierName;
                    }
                  });
                }
              }
            }
            return h('div', [
              h('p', text),
              h('p', code)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'),
          key: 'supplierMerchantId',
          minWidth: 120,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004048'),
          key: 'packageQuantity',
          minWidth: 150,
          align: 'center',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          align: 'center',
          minWidth: 180,
          sortable: true,
          render: (h, params) => {
            return h('span', v.$uDate.getDataToLocalTime(params.row.createdTime, 'fulltime'));
          }
        },
      ],
      tableData: [],
      useLogisticsList: [],
    };
  },
  created() {
    this.getUseLogistics();
  },
  mounted() {
    let v = this;
    v.$nextTick(() => {
      v.getFocus('scanning');
    });
  },
  methods: {
    // 获取使用过的物流商数据
    getUseLogistics() {
      this.useLogisticsList = [];
      this.axios.get(api.get_expressageHundred_query + '?type=kuaidi100').then(response => {
        if (response.data.code === 0) {
          let typeShippingList = response.data.datas || [];
          if (typeShippingList.length > 0) {
            this.axios.get(api.get_ymsPickupOrder_queryLogistics).then(response => {
              if (response.data.code === 0) {
                let data = response.data.datas || [];
                if (data.length > 0) {
                  data.map((item) => {
                    typeShippingList.map((ele) => {
                      if (item.carrierId === ele.code) {
                        item.carrierName = ele.name;
                      }
                    });
                  });
                  this.useLogisticsList = data;
                  this.useLogisticsList.unshift({carrierId: "ymspickcollec", carrierName: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001582')}`});
                }
              }
            });
          }
        }
      });
    },
    // 提单号的回车键
    enterScanInput() {
      let v = this;
      if (v.scanInput !== '') {
        v.axios.put(api.put_ymsPickupOrder_warehousing + `${v.scanInput}`).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            v.tableData.push(data);
            v.scanInput = '';
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004049'));
            v.$nextTick(() => {
              v.getFocus('scanning');
            });
          }
        });
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004050'));
      }
    }
  }
};
</script>

<style lang="less" scoped>
.container_box {
  padding-top: 30px;
  background-color: #fff;
  min-height: 750px;

  .billWarehousing_box {
    width: 70%;
    margin: 0 auto;
    border: 1px solid #CCCCCC;
    border-radius: 30px;
    padding: 40px 0 30px 0;
    text-align: center;

    .title {
      font-weight: bold;
      font-size: 25px;
      color: #333;
    }

    .scan_input {
      width: 70%;
      margin: 20px auto 10px;
    }
  }

  .table_box {
    width: 70%;
    margin: 30px auto 0;
  }
}
</style>
